import * as yup from 'yup';

const validateSchema = yup.object().shape({
  customerId: yup.string().required(),
  pickupDate: yup.string().required(),
});

export default validateSchema;
